"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewTree = exports.TreeEntity = exports.NewCascader = exports.CascaderEntity = exports.DataTree = void 0;
var flattenTree_1 = __importDefault(require("../../utility/flattenTree"));
var array_1 = require("../../utility/array");
var copy = function (o) {
    return JSON.parse(JSON.stringify(o));
};
var DataTree = /** @class */ (function () {
    function DataTree(data, type, options) {
        var _this = this;
        this.getTreeData = function (data, type, options) {
            options = options || {};
            if (type === "list") {
                var listdata = array_1.listToTree(data, options.parentIdStart, options.parentKey);
                // @ts-ignore:
                return flattenTree_1.default(listdata, options);
            }
            else if (type === "tree") {
                return flattenTree_1.default(data, options);
            }
            if (type === "tree") {
                return flattenTree_1.default(data, options);
            }
            return null;
        };
        // 获取节点，多个用’,‘隔开
        this.getNodes = function (attrs, attr) {
            if (attr === void 0) { attr = "id"; }
            if (_this.levelData) {
                var idsArray_1 = ("" + attrs).split(",");
                var levelData = _this.levelData;
                var currNode = levelData.filter(function (item) {
                    if (item && "" + item[attr]) {
                        return idsArray_1.indexOf("" + item[attr]) > -1;
                    }
                    return null;
                });
                return currNode;
            }
            return [];
        };
        // 获取祖先所有节点;
        this.getAncestors = function (id) {
            var nodeArr = [];
            // @ts-ignore:
            var getNode = function (currNode) {
                if (currNode) {
                    var cc = currNode.parentId;
                    nodeArr = __spread(nodeArr, [cc]);
                    if (cc) {
                        return getNode(_this.getNodes(cc)[0]);
                    }
                }
                return nodeArr;
            };
            return getNode(_this.getNodes(id)[0]);
        };
        // 获取后代所有节点
        this.getOffspring = function (id) {
            var _a;
            var nodeArr = [];
            var childrenKeyName = ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.childrenKeyName) ? _this.options.childrenKeyName
                : "children";
            var getNode = function (currNode) {
                if (currNode) {
                    // @ts-ignore:
                    var cc = currNode[childrenKeyName];
                    if (cc) {
                        nodeArr = __spread(nodeArr, cc);
                        cc.forEach(function (innerid) {
                            return getNode(_this.getNodes(innerid)[0]);
                        });
                    }
                }
                return nodeArr;
            };
            return getNode(_this.getNodes(id)[0]);
        };
        this.souceData = data;
        this.levelData = this.getTreeData(copy(data), type, options);
        this.options = options;
    }
    return DataTree;
}());
exports.DataTree = DataTree;
var CascaderEntity = /** @class */ (function (_super) {
    __extends(CascaderEntity, _super);
    function CascaderEntity(data, type, options) {
        var _this = _super.call(this, data, (type = "tree"), options) || this;
        _this.getLevelData = function (level) {
            var tempData = [];
            if (_this.DATA) {
                var rootData = _this.DATA.filter(function (item) { return item.tLevel === level; });
                tempData[level - 1] = rootData;
            }
            return tempData;
        };
        // 获取点击当前数据
        _this.getActive = function (item) {
            if (!(item && item.id)) {
                return {
                    showNode: [],
                    currNode: [],
                };
            }
            var tLevel = item.tLevel || 1;
            var tempData = [];
            var ancestors = _this.getAncestors(item.id);
            var filterData = _this.getNodes(ancestors.join(","), "parentId");
            var currIds = __spread(ancestors, [item.id]);
            var currNode = _this.getNodes(currIds.join(","));
            var _loop_1 = function (i) {
                var data = filterData.filter(function (item) { return item.tLevel === i + 1; });
                tempData[i] = data.map(function (item) {
                    var iItem = item;
                    if (currIds.indexOf(item.id) > -1) {
                        iItem = __assign(__assign({}, item), { curr: true });
                    }
                    return iItem;
                });
            };
            for (var i = 0; i < tLevel; i++) {
                _loop_1(i);
            }
            if (item.isRoot) {
                var childrenKeyName = _this.options && _this.options.childrenKeyName
                    ? _this.options.childrenKeyName
                    : "children";
                var childData = _this.getNodes(item[childrenKeyName].join(","));
                tempData[tLevel] = childData;
            }
            var resObj = { showNode: tempData, currNode: currNode };
            return resObj;
        };
        // 获取搜索时横向数据
        _this.getLeaf = function () {
            var leafNodeList = _this.DATA.filter(function (item) { return !item.isRoot; });
            var leafNodeLists = leafNodeList.map(function (node) {
                if (node && node.id) {
                    var parents = _this.getAncestors(node.id);
                    var tempNode = __spread(parents, [node.id]);
                    return _this.getNodes(tempNode.join(","));
                }
                return [];
            });
            return leafNodeLists;
        };
        _this.cascaderData = [];
        _this.DATA = _this.levelData;
        return _this;
    }
    return CascaderEntity;
}(DataTree));
exports.CascaderEntity = CascaderEntity;
function NewCascader(data, type, options) {
    return new CascaderEntity(data, type, options);
}
exports.NewCascader = NewCascader;
var TreeEntity = /** @class */ (function (_super) {
    __extends(TreeEntity, _super);
    function TreeEntity(data, type, options) {
        var _this = _super.call(this, data, (type = "tree"), options) || this;
        _this.getNodes = function (attrs, attr) {
            if (attr === void 0) { attr = "id"; }
            if (_this.DATA) {
                var idsArray_2 = ("" + attrs).split(",");
                var levelData = _this.DATA;
                var currNode = levelData.filter(function (item) {
                    if (item && "" + item[attr]) {
                        return idsArray_2.indexOf("" + item[attr]) > -1;
                    }
                    return null;
                });
                return currNode;
            }
            return [];
        };
        _this.isValidMove = function (id, targetId) {
            if (id === targetId) {
                return false;
            }
            var pIds = _this.getAncestors(targetId);
            if (pIds.indexOf(id) > -1) {
                return false;
            }
            return true;
        };
        _this.append = function (fromid, destId) {
            var sNode = _this.getNodes(fromid)[0];
            var tNode = _this.getNodes(destId)[0];
            var sPId = sNode.parentId;
            var sPNode = _this.getNodes(sPId)[0];
            var childrenKeyName = _this.options && _this.options.childrenKeyName
                ? _this.options.childrenKeyName
                : "children";
            sNode.parentId = destId;
            if (sPNode && sPNode[childrenKeyName]) {
                sPNode[childrenKeyName] = sPNode[childrenKeyName].filter(function (i) { return i !== fromid; });
            }
            tNode[childrenKeyName] = tNode[childrenKeyName]
                ? __spread(tNode[childrenKeyName], [fromid]) : [fromid];
            _this.insert(sNode, tNode, sPNode);
        };
        _this.insertBefore = function (fromid, destId) {
            var sNode = _this.getNodes(fromid)[0];
            var tNode = _this.getNodes(destId)[0];
            var sPId = sNode.parentId;
            var sPNode = _this.getNodes(sPId)[0];
            var pId = tNode.parentId;
            var pNode = _this.getNodes(pId)[0];
            var childrenKeyName = _this.options && _this.options.childrenKeyName
                ? _this.options.childrenKeyName
                : "children";
            sNode.parentId = pId;
            if (pNode && pNode[childrenKeyName]) {
                var pChild = pNode[childrenKeyName];
                if (sPId === pId) {
                    pChild = pChild.filter(function (c) { return c !== fromid; });
                }
                var index = pChild.indexOf(destId);
                var temp = pChild;
                temp.splice(index, 0, fromid);
                pNode[childrenKeyName] = __spread(new Set(temp));
            }
            if (sPNode && sPNode[childrenKeyName] && sPId !== pId) {
                sPNode[childrenKeyName] = sPNode[childrenKeyName].filter(function (i) { return i !== fromid; });
            }
            _this.insert(sNode, pNode, sPNode);
        };
        _this.insertAfter = function (fromid, destId) {
            var sNode = _this.getNodes(fromid)[0];
            var tNode = _this.getNodes(destId)[0];
            var pId = tNode.parentId;
            var pNode = _this.getNodes(pId)[0];
            var sPId = sNode.parentId;
            var sPNode = _this.getNodes(sPId)[0];
            var childrenKeyName = _this.options && _this.options.childrenKeyName
                ? _this.options.childrenKeyName
                : "children";
            sNode.parentId = pId;
            if (pNode) {
                var pChild = pNode[childrenKeyName];
                if (sPId === pId) {
                    pChild = pChild.filter(function (c) { return c !== fromid; });
                }
                var index = pChild.indexOf(destId);
                var temp = pChild;
                temp.splice(index + 1, 0, fromid);
                pNode[childrenKeyName] = __spread(new Set(temp));
            }
            if (sPNode && sPNode[childrenKeyName] && sPId !== pId) {
                sPNode[childrenKeyName] = sPNode[childrenKeyName].filter(function (i) { return i !== fromid; });
            }
            _this.insert(sNode, pNode, sPNode);
        };
        _this.insert = function (sNode, tNode, sPNode) {
            var tempData = _this.DATA.map(function (data) {
                if (data.id === sNode.id) {
                    return sNode;
                }
                else if (tNode && data.id === tNode.id) {
                    return tNode;
                }
                else if (sPNode && data.id === sPNode.id) {
                    return sPNode;
                }
                return data;
            });
            _this.DATA = tempData;
        };
        _this.cascaderData = [];
        _this.DATA = _this.levelData;
        return _this;
    }
    return TreeEntity;
}(DataTree));
exports.TreeEntity = TreeEntity;
function NewTree(data, type, options) {
    return new TreeEntity(data, type, options);
}
exports.NewTree = NewTree;
